// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_ADD_EVENT = "addEvent"; // Count: 6
export var _DYN_PUSH = "push"; // Count: 18
export var _DYN_LENGTH = "length"; // Count: 52
export var _DYN_CLEAR = "clear"; // Count: 5
export var _DYN_GET_ITEMS = "getItems"; // Count: 4
export var _DYN_SPLIT = "split"; // Count: 5
export var _DYN_INITIALIZE = "initialize"; // Count: 11
export var _DYN_DIAG_LOG = "diagLog"; // Count: 6
export var _DYN_STORAGE_CONFIG = "storageConfig"; // Count: 4
export var _DYN_VALUE = "value"; // Count: 10
export var _DYN_REJECTED = "rejected"; // Count: 6
export var _DYN_SEND_NEXT_BATCH = "sendNextBatch"; // Count: 3
export var _DYN_GET_NEXT_BATCH = "getNextBatch"; // Count: 5
export var _DYN_REMOVE_EVENTS = "removeEvents"; // Count: 3
export var _DYN_DATA = "data"; // Count: 11
export var _DYN_ATTEMP_CNT = "attempCnt"; // Count: 4
export var _DYN_STATE = "state"; // Count: 9
export var _DYN_TEARDOWN = "teardown"; // Count: 6
export var _DYN_IS_ARR = "isArr"; // Count: 5
export var _DYN_INDEX_OF = "indexOf"; // Count: 9
export var _DYN_CANCEL = "cancel"; // Count: 5
export var _DYN_PROCESS_NEXT = "processNext"; // Count: 3
export var _DYN_PERSISTENCE = "persistence"; // Count: 11
export var _DYN_ONUNLOAD_FLUSH = "onunloadFlush"; // Count: 3
export var _DYN_BATCH_HANDLER = "batchHandler"; // Count: 5
export var _DYN_MIN_PERSISTENCE_CACH0 = "minPersistenceCacheLevel"; // Count: 2
export var _DYN_REFRESH = "refresh"; // Count: 4
export var _DYN_CRITICAL_CNT = "criticalCnt"; // Count: 8
export var _DYN_IS_COMPLETELY_IDLE = "isCompletelyIdle"; // Count: 5
export var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 4
export var _DYN_OVERRIDE_INSTRUMENTA1 = "overrideInstrumentationKey"; // Count: 2
export var _DYN_NOTIFICATION_MGR = "notificationMgr"; // Count: 3
export var _DYN_TO_STRING = "toString"; // Count: 5
export var _DYN_CHAR_CODE_AT = "charCodeAt"; // Count: 3
export var _DYN_CHAR_AT = "charAt"; // Count: 8
export var _DYN_FROM_CHAR_CODE = "fromCharCode"; // Count: 3
export var _DYN_GET_TIME = "getTime"; // Count: 5
export var _DYN_DB_HDL = "dbHdl"; // Count: 7
export var _DYN_IS_AVAILABLE = "isAvailable"; // Count: 8
export var _DYN_TRANSACTION = "transaction"; // Count: 5
export var _DYN_OPEN_CURSOR = "openCursor"; // Count: 3
export var _DYN_ONERROR = "onerror"; // Count: 9
export var _DYN_ONSUCCESS = "onsuccess"; // Count: 7
export var _DYN_THEN = "then"; // Count: 12
export var _DYN_CONTINUE = "continue"; // Count: 6
export var _DYN__EVENTS_TO_DROP_PER_2 = "EventsToDropPerTime"; // Count: 2
export var _DYN_MAX_CRITICAL_EVTS_DR3 = "maxCriticalEvtsDropCnt"; // Count: 2
export var _DYN_SUPPORTS_SYNC_REQUES4 = "supportsSyncRequests"; // Count: 2
export var _DYN_REMOVE_ITEM = "removeItem"; // Count: 3
export var _DYN_EVTS = "evts"; // Count: 6
export var _DYN_LAST_ACCESS_TIME = "lastAccessTime"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map